import React, { Fragment } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import "../../assets/css/scss/section/_activity.scss";
import "../../assets/css/scss/component/_activityIcon.scss";
import CountUp from 'react-countup';
import { ICountData } from '../../interfaces/post';
interface IActivityCounter {
    countList: ICountData[]
}
const firstIcon = <span className="icon icon-Asset-3"><span className="path1"></span><span className="path2"></span><span className="path3"></span><span className="path4"></span><span className="path5"></span></span>;

const secondIcon = <span className="icon icon-Asset-1"><span className="path1"></span><span className="path2"></span><span className="path3"></span><span className="path4"></span><span className="path5"></span><span className="path6"></span><span className="path7"></span><span className="path8"></span><span className="path9"></span><span className="path10"></span></span>;

const thirdIcon = <span className="icon icon-Asset-2"><span className="path1"></span><span className="path2"></span><span className="path3"></span><span className="path4"></span><span className="path5"></span></span>;

export default function ActivityCounter(props: IActivityCounter) {
    return (
        <Fragment>
            <section className="counter-section theme-dark-gray">
                <Container>
                    <Row>
                        {props?.countList.map((data: ICountData, index) => (
                            <Col xs={6} sm={(12 / props?.countList.length) < 3 ? 3 : (12 / props?.countList.length)} className={"mb-4 " + (props?.countList.length > 4 ? "mb-sm-4" : "mb-sm-0")}>
                                <div className="d-block d-lg-flex align-items-center text-center text-lg-left">
                                    {index + 1 === 1 || index + 1 === 4 || index + 1 === 7
                                        ? firstIcon
                                        : index + 1 === 2 || index + 1 === 5 || index + 1 === 8 ?
                                            secondIcon
                                            : index + 1 === 3 || index + 1 === 6 || index + 1 === 9 ?
                                                thirdIcon : ""}
                                    <div className="mt-2 mt-lg-0 ml-lg-3 ml-xl-4">
                                        <h3 className="bold theme-green mb-2 counting" data-count="800"><CountUp end={data?.count ? data.count : 0} delay={2} start={0} duration={2} /></h3>
                                        <p className="h6 theme-white">{data?.title}</p>
                                    </div>
                                </div>
                            </Col>
                        ))}
                        {/* <Col xs={6} sm={3} className="mb-4 mb-sm-0">
                            <div className="d-block d-lg-flex align-items-center text-center text-lg-left">
                                <span className="icon icon-Asset-1"><span className="path1"></span><span className="path2"></span><span className="path3"></span><span className="path4"></span><span className="path5"></span><span className="path6"></span></span>
                                <div className="mt-2 mt-lg-0 ml-lg-3 ml-xl-4">
                                    <h3 className="bold theme-green mb-2 counting" data-count="800"><CountUp end={100} delay={2} start={0} duration={2} /></h3>
                                    <p className="h6 theme-white">Match Winner</p>
                                </div>
                            </div>
                        </Col>
                        <Col xs={6} sm={3}>
                            <div className="d-block d-lg-flex align-items-center text-center text-lg-left">
                                <span className="icon icon-Asset-2"><span className="path1"></span><span className="path2"></span><span className="path3"></span><span className="path4"></span><span className="path5"></span></span>
                                <div className="mt-2 mt-lg-0 ml-lg-3 ml-xl-4">
                                    <h3 className="bold theme-green mb-2 counting" data-count="800"><CountUp end={100} delay={2} start={0} duration={2} /></h3>
                                    <p className="h6 theme-white">Match Winner</p>
                                </div>
                            </div>
                        </Col>
                        <Col xs={6} sm={3}>
                            <div className="d-block d-lg-flex align-items-center text-center text-lg-left">
                                <span className="icon icon-Asset-1"><span className="path1"></span><span className="path2"></span><span className="path3"></span><span className="path4"></span><span className="path5"></span><span className="path6"></span></span>
                                <div className="mt-2 mt-lg-0 ml-lg-3 ml-xl-4">
                                    <h3 className="bold theme-green mb-2 counting" data-count="800"><CountUp end={100} delay={2} start={0} duration={2} /></h3>
                                    <p className="h6 theme-white">Match Winner</p>
                                </div>
                            </div>
                        </Col> */}
                    </Row>
                </Container>
            </section>
        </Fragment>
    )
}
